
(function(){
  const header=document.getElementById('header');
  const loader=document.getElementById('loader');
  const mobileNav=document.getElementById('mobileNav');
  const hamb=document.getElementById('hamb');
  window.addEventListener('load',()=>{if(loader)setTimeout(()=>loader.classList.add('done'),500)});
  const onHeader=()=>{if(header)header.classList.toggle('scrolled',scrollY>18)}; addEventListener('scroll',onHeader,{passive:true});onHeader();
  if(false&&hamb&&mobileNav){hamb.addEventListener('click',()=>{mobileNav.classList.toggle('open');hamb.classList.toggle('open')});mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mobileNav.classList.remove('open');hamb.classList.remove('open')}))}

  const revealEls=[...document.querySelectorAll('.reveal')];
  const revIO=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');revIO.unobserve(e.target)}}),{threshold:.14,rootMargin:'0px 0px -6% 0px'}); revealEls.forEach(el=>revIO.observe(el));

  /* Performance: below-fold videos use preload=none. Only play videos that are actually visible,
     and never run hidden RIVARIE System tab videos in the background. */
  const vids=[...document.querySelectorAll('video')];
  const syncVideo=v=>{
    const systemPanel=v.closest('.prm-system-media');
    const canPlay=v.dataset.rvInView==='1' && (!systemPanel || systemPanel.classList.contains('is-active'));
    if(canPlay){v.play().catch(()=>{});}else{v.pause();}
  };
  window.__rvSyncVideo=syncVideo;
  if('IntersectionObserver' in window){
    const vio=new IntersectionObserver(es=>es.forEach(e=>{
      e.target.dataset.rvInView=e.isIntersecting?'1':'0';
      syncVideo(e.target);
    }),{threshold:.12,rootMargin:'160px 0px 160px 0px'});
    vids.forEach(v=>vio.observe(v));
  }else{
    vids.forEach(v=>{v.dataset.rvInView='1';syncVideo(v)});
  }

  /* preserve Material Intelligence scroll expansion */
  const craft=document.querySelector('.xp-craft'), media=document.querySelector('.xp-expand-media'), title=document.querySelector('.xp-craft-title'), mask=document.querySelector('.xp-color-mask'), divider=document.querySelector('.xp-divider'), meta=document.querySelector('.xp-film-meta'), line=document.querySelector('.xp-film-line');
  function craftUpdate(){if(!craft||!media)return;const r=craft.getBoundingClientRect();const max=Math.max(1,craft.offsetHeight-innerHeight);let p=Math.min(1,Math.max(0,-r.top/max));const ease=1-Math.pow(1-p,3);const startW=innerWidth<600?118:180,startH=innerWidth<600?160:238,endW=innerWidth*.94,endH=innerHeight*.82;media.style.width=(startW+(endW-startW)*ease)+'px';media.style.height=(startH+(endH-startH)*ease)+'px';media.style.borderRadius=(Math.max(0,10*(1-ease)))+'px';if(title){title.style.opacity=String(Math.max(.06,1-p*1.55));title.style.transform=`scale(${1-p*.06}) translateY(${-p*18}px)`}const wipe=Math.max(0,Math.min(1,(p-.45)/.42));if(mask)mask.style.clipPath=`inset(0 ${(1-wipe)*100}% 0 0)`;if(divider){divider.style.left=(wipe*100)+'%';divider.style.opacity=wipe>0&&wipe<.99?'.9':'0'}const appear=Math.max(0,Math.min(1,(p-.52)/.22));if(meta)meta.style.opacity=appear;if(line)line.style.opacity=appear}

  /* 02 motion language — reference-driven expanding cinema */
  const motion=document.querySelector('.rv-motion'), motionMedia=document.getElementById('rvMotionMedia');
  const motionVid=motionMedia?motionMedia.querySelector('video'):null;
  const motionGhosts=[...document.querySelectorAll('.rv-motion-ghost')];
  const motionBuilt=document.querySelector('.rv-motion-built');
  function motionUpdate(){if(!motion||!motionMedia)return;const r=motion.getBoundingClientRect();const max=Math.max(1,motion.offsetHeight-innerHeight);let p=Math.min(1,Math.max(0,-r.top/max));const e=1-Math.pow(1-p,3);const sw=innerWidth<700?innerWidth*.76:innerWidth*.42, sh=innerWidth<700?innerHeight*.46:innerHeight*.54;const ew=innerWidth*.94, eh=innerHeight*.84;motionMedia.style.width=(sw+(ew-sw)*e)+'px';motionMedia.style.height=(sh+(eh-sh)*e)+'px';if(motionVid){motionVid.style.filter=`grayscale(${Math.max(0,1-p*1.55)})`;motionVid.style.transform=`scale(${1.03-p*.03})`}motionGhosts.forEach((g,i)=>{g.style.opacity=String(Math.max(.08,1-p*1.6));g.style.transform=`translateY(${(i?1:-1)*p*28}px)`});if(motionBuilt){const a=Math.max(0,Math.min(1,(p-.62)/.25));motionBuilt.style.opacity=a;motionBuilt.style.transform=`translateY(${15*(1-a)}px)`}}

  /* One animation-frame update for both scroll-driven sections instead of multiple heavy scroll handlers. */
  let rvFrame=0;
  const scheduleMotionFrame=()=>{
    if(rvFrame)return;
    rvFrame=requestAnimationFrame(()=>{rvFrame=0;craftUpdate();motionUpdate()});
  };
  if(craft||motion){
    addEventListener('scroll',scheduleMotionFrame,{passive:true});
    addEventListener('resize',scheduleMotionFrame,{passive:true});
    scheduleMotionFrame();
  }

  /* 04 interactive rhythm panels */
  document.querySelectorAll('.rv-rhythm').forEach(panel=>{panel.addEventListener('mouseenter',()=>{document.querySelectorAll('.rv-rhythm').forEach(x=>x.classList.remove('active'));panel.classList.add('active');const v=panel.querySelector('video');if(v)v.play().catch(()=>{})})});

  /* 05 typed principle */
  const target=document.querySelector('.rv-type-target');
  if(target){const observer=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting||target.dataset.done)return;target.dataset.done='1';const t=target.dataset.text||'';let i=0;const tick=()=>{target.textContent=t.slice(0,i);if(i<t.length){i++;setTimeout(tick,28)}else{const caret=document.querySelector('.rv-type-caret');if(caret)setTimeout(()=>caret.style.opacity='0',900)}};tick();observer.disconnect()}),{threshold:.5});observer.observe(target)}
})();



(function(){
 const tabs=[...document.querySelectorAll('.prm-system-tabs button')];
 const media=[...document.querySelectorAll('.prm-system-media')];
 const copy=[...document.querySelectorAll('.prm-system-state')];
 function activate(key){
   tabs.forEach(b=>b.classList.toggle('is-active',b.dataset.target===key));
   media.forEach(m=>{
     m.classList.toggle('is-active',m.dataset.panel===key);
     const v=m.querySelector('video');
     if(v&&window.__rvSyncVideo)window.__rvSyncVideo(v);
   });
   copy.forEach(c=>c.classList.toggle('is-active',c.dataset.copy===key));
 }
 tabs.forEach(b=>{b.addEventListener('mouseenter',()=>activate(b.dataset.target));b.addEventListener('click',()=>activate(b.dataset.target));});
 const filters=[...document.querySelectorAll('.prm-filter button')];
 filters.forEach(b=>b.addEventListener('click',()=>{filters.forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active')}));
})();



document.querySelectorAll('.prm-swatches').forEach(group=>{
  group.querySelectorAll('.prm-swatch').forEach(swatch=>{
    swatch.addEventListener('click',e=>{
      e.preventDefault();
      group.querySelectorAll('.prm-swatch').forEach(x=>x.classList.remove('is-active'));
      swatch.classList.add('is-active');
    });
  });
});
document.querySelectorAll('.prm-shop-pin').forEach(pin=>{
  pin.addEventListener('click',e=>{
    e.preventDefault(); e.stopPropagation();
    const card=pin.nextElementSibling;
    const wasOpen=pin.classList.contains('is-open');
    document.querySelectorAll('.prm-shop-pin').forEach(p=>p.classList.remove('is-open'));
    document.querySelectorAll('.prm-pin-card').forEach(c=>c.classList.remove('is-open'));
    if(!wasOpen){pin.classList.add('is-open'); if(card&&card.classList.contains('prm-pin-card')) card.classList.add('is-open');}
  });
});
document.addEventListener('click',()=>{
  document.querySelectorAll('.prm-shop-pin').forEach(p=>p.classList.remove('is-open'));
  document.querySelectorAll('.prm-pin-card').forEach(c=>c.classList.remove('is-open'));
});



(function(){
  const luxSpots=[...document.querySelectorAll('.lux-shopspot')];
  const INSET=14;
  const GAP=12;

  function positionLuxSpot(spot){
    const card=spot.closest('.lux-social-card');
    const pin=spot.querySelector('.lux-pin');
    const pop=spot.querySelector('.lux-pin-pop');
    if(!card||!pin||!pop) return;

    /* Make measurable without flashing it onscreen. */
    const oldVisibility=pop.style.getPropertyValue('visibility');
    const oldOpacity=pop.style.getPropertyValue('opacity');
    pop.style.setProperty('display','block','important');
    pop.style.setProperty('visibility','hidden','important');
    pop.style.setProperty('opacity','0','important');
    pop.style.setProperty('transform','none','important');

    const cardRect=card.getBoundingClientRect();
    const pinRect=pin.getBoundingClientRect();
    const spotRect=spot.getBoundingClientRect();
    const pw=pop.offsetWidth;
    const ph=pop.offsetHeight;

    const minLeft=cardRect.left+INSET;
    const maxLeft=Math.max(minLeft,cardRect.right-INSET-pw);
    const rightCandidate=pinRect.right+GAP;
    const leftCandidate=pinRect.left-GAP-pw;
    let leftViewport;

    if(rightCandidate<=maxLeft){
      leftViewport=rightCandidate;
    }else if(leftCandidate>=minLeft){
      leftViewport=leftCandidate;
    }else{
      leftViewport=Math.min(maxLeft,Math.max(minLeft,(pinRect.left+pinRect.width/2)-(pw/2)));
    }

    const minTop=cardRect.top+INSET;
    const maxTop=Math.max(minTop,cardRect.bottom-INSET-ph);
    let topViewport=(pinRect.top+pinRect.height/2)-(ph/2);
    topViewport=Math.min(maxTop,Math.max(minTop,topViewport));

    pop.style.setProperty('left',(leftViewport-spotRect.left)+'px','important');
    pop.style.setProperty('top',(topViewport-spotRect.top)+'px','important');
    pop.style.setProperty('right','auto','important');

    if(oldVisibility) pop.style.setProperty('visibility',oldVisibility,'important'); else pop.style.removeProperty('visibility');
    if(oldOpacity) pop.style.setProperty('opacity',oldOpacity,'important'); else pop.style.removeProperty('opacity');
    pop.style.removeProperty('transform');
  }

  function showLuxSpot(spot){
    const pin=spot.querySelector('.lux-pin');
    const pop=spot.querySelector('.lux-pin-pop');
    if(!pop) return;
    positionLuxSpot(spot);
    if(pin) pin.setAttribute('aria-expanded','true');
    pop.style.setProperty('display','block','important');
    pop.style.setProperty('opacity','1','important');
    pop.style.setProperty('visibility','visible','important');
    pop.style.setProperty('pointer-events','auto','important');
    pop.style.setProperty('transform','translateY(0) scale(1)','important');
  }

  function hideLuxSpot(spot){
    const pin=spot.querySelector('.lux-pin');
    const pop=spot.querySelector('.lux-pin-pop');
    if(pin) pin.setAttribute('aria-expanded','false');
    if(!pop) return;
    pop.style.removeProperty('display');
    pop.style.removeProperty('opacity');
    pop.style.removeProperty('visibility');
    pop.style.removeProperty('pointer-events');
    pop.style.removeProperty('transform');
  }

  function closeLuxSpots(except=null){
    luxSpots.forEach(spot=>{
      if(spot!==except){spot.classList.remove('is-open');hideLuxSpot(spot)}
    });
  }

  luxSpots.forEach(spot=>{
    const btn=spot.querySelector('.lux-pin');
    const pop=spot.querySelector('.lux-pin-pop');
    if(!btn||!pop) return;

    spot.addEventListener('mouseenter',()=>{closeLuxSpots(spot);showLuxSpot(spot)});
    spot.addEventListener('mouseleave',()=>{if(!spot.classList.contains('is-open'))hideLuxSpot(spot)});
    btn.addEventListener('focus',()=>showLuxSpot(spot));
    btn.addEventListener('blur',()=>{if(!spot.classList.contains('is-open'))hideLuxSpot(spot)});

    btn.addEventListener('click',e=>{
      e.preventDefault();
      e.stopPropagation();
      const willOpen=!spot.classList.contains('is-open');
      closeLuxSpots();
      if(willOpen){spot.classList.add('is-open');showLuxSpot(spot)}
    });

    pop.addEventListener('click',e=>e.stopPropagation());
  });

  document.addEventListener('click',()=>closeLuxSpots());
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeLuxSpots()});
  window.addEventListener('resize',()=>luxSpots.forEach(spot=>{if(spot.matches(':hover')||spot.classList.contains('is-open'))positionLuxSpot(spot)}));
})();
